import { HostListener, Component, Directive } from "@angular/core";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { isEqual } from "lodash";

@Directive({})
export class UnsavedChangesDeactivate {
    constructor(public sharedService: SharedService) {}
    canDeactivate(): boolean {
        this.sharedService.unsavedData = !isEqual(this.sharedService.originalData, this.sharedService.changedData);
        return !this.sharedService.unsavedData;
    }

    @HostListener("window:beforeunload", ["$event"])
    unloadNotification($event: any) {
        this.sharedService.unsavedData = !isEqual(this.sharedService.originalData, this.sharedService.changedData);
        if (!this.canDeactivate() && this.sharedService.unsavedData) {
            $event.returnValue = true;
        }
    }
}
